<!--<template>-->
<!--  <div class="container">-->
<!--    <div class="row min-vh-100 align-items-center justify-content-center py-4">-->
<!--      <div class="col-12 col-lg-9 col-xl-8">-->
<!--        <div class="card shadow border-0">-->
<!--          <div class="row g-0">-->
<!--            &lt;!&ndash; Image Section &ndash;&gt;-->
<!--            <div class="col-12 col-md-6" style="padding: 30px">-->
<!--              <img-->
<!--                  :src="require('@/assets/img/ff.png')"-->
<!--                  alt="Login image"-->
<!--                  class="w-100 login-image"-->
<!--                  style="border-radius: 0.375rem 0.375rem 0 0; object-position: center;"-->
<!--              />-->
<!--            </div>-->

<!--            &lt;!&ndash; Form Section &ndash;&gt;-->
<!--            <div class="col-12 col-md-6 bg-dark text-light d-flex align-items-center justify-content-center">-->
<!--              <div class="card-body p-4 p-md-5">-->
<!--                <h2 class="text-center mb-4 fw-bold">MyHD</h2>-->
<!--                <form @submit.prevent="handleSubmit">-->
<!--                  <div class="mb-3">-->
<!--                    <label for="email" class="form-label" style="font-size: small">-->
<!--                      Email address-->
<!--                    </label>-->
<!--                    <input-->
<!--                        type="email"-->
<!--                        class="form-control form-control-lg"-->
<!--                        id="email"-->
<!--                        v-model="email"-->
<!--                        placeholder="name@example.com"-->
<!--                        style="border-radius: 0; font-size: small"-->
<!--                        required-->
<!--                    />-->
<!--                  </div>-->
<!--                  <div class="mb-3 text-lg">-->
<!--                    <label for="password" class="form-label" style="font-size: small">-->
<!--                      Password-->
<!--                    </label>-->
<!--                    <input-->
<!--                        type="password"-->
<!--                        class="form-control form-control-lg"-->
<!--                        id="password"-->
<!--                        v-model="password"-->
<!--                        style="border-radius: 0; font-size: small"-->
<!--                        required-->
<!--                    />-->
<!--                  </div>-->
<!--                  <div class="mb-4">-->
<!--                    <div class="d-flex justify-content-end">-->
<!--                      <a-->
<!--                          href="#"-->
<!--                          class="text-decoration-none"-->
<!--                          style="font-size: small"-->
<!--                          @click.prevent="handleForgotPassword"-->
<!--                      >-->
<!--                        Forgot password?-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <button-->
<!--                      type="submit"-->
<!--                      class="btn btn-primary btn-lg w-100 mb-2"-->
<!--                      style="border-radius: 0; font-size: small"-->
<!--                  >-->
<!--                    Login-->
<!--                  </button>-->
<!--                  <p class="text-center mb-0" style="font-size: small">-->
<!--                    Don't have an account?-->
<!--                    <a-->
<!--                        href="#"-->
<!--                        class="text-decoration-none"-->
<!--                        @click.prevent="handleSignup"-->
<!--                    >-->
<!--                      Sign up-->
<!--                    </a>-->
<!--                  </p>-->
<!--                </form>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: 'LoginPage',-->
<!--  data() {-->
<!--    return {-->
<!--      email: '',-->
<!--      password: ''-->
<!--    }-->
<!--  },-->
<!--  methods: {-->
<!--    handleSubmit() {-->
<!--      // Handle login logic here-->
<!--      console.log('Login attempted with:', {-->
<!--        email: this.email,-->
<!--        password: this.password-->
<!--      })-->
<!--    },-->
<!--    handleForgotPassword() {-->
<!--      // Handle forgot password logic-->
<!--      console.log('Forgot password clicked')-->
<!--    },-->
<!--    handleSignup() {-->
<!--      // Handle signup navigation-->
<!--      console.log('Signup clicked')-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style>-->
<!--body {-->
<!--  background: linear-gradient(to bottom, #a1c4fd 0%, #c2e9fb 100%);-->
<!--  min-height: 100vh;-->
<!--}-->

<!--.login-image {-->
<!--  max-height: 300px;-->
<!--  object-fit: cover;-->
<!--}-->

<!--@media (min-width: 768px) {-->
<!--  .login-image {-->
<!--    max-height: 100%;-->
<!--    min-height: 400px;-->
<!--  }-->
<!--}-->
<!--</style>-->

<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100 p-t-85 p-b-20">
        <div class="login100-form validate-form">
          <!-- <span>
            <b><p style="color: #000;">Please take note of the following website and mobile app maintenance schedule:</p></b>
            <p style="color: #000;">10/10/2020 18:00 until 12/10/2020 04:00</p>
          </span> -->
          <span class="login100-form-title p-b-70">
            MyHD
          </span>
          <span>
            <center>
              <img v-bind="mainProps" src="@/assets/img/ff.png" alt="AVATAR" />
            </center>
          </span>

          <div
            class="wrap-input100 validate-input m-t-85 m-b-35"
            data-validate="Enter Email"
          >
            <p>Email</p>
            <input
              v-model="data.email"
              class="input100"
              type="text"
              name="email"
            />
            <!-- <span class="focus-input100" data-placeholder="Email"></span> -->
          </div>

          <div
            class="wrap-input100 validate-input m-b-50"
            data-validate="Enter password"
          >
            <p>Password</p>
            <input
              v-model="data.password"
              class="input100"
              type="password"
              name="pass"
            />
            <!-- <span class="focus-input100" data-placeholder="Password"></span> -->
          </div>

          <div class="container-login100-form-btn">
            <button class="login100-form-btn" @click="onClickLogin">
              LOGIN
            </button>
            <p v-if="error.submit">
              <span class="danger-new">{{ this.error.submit }}</span>
            </p>
          </div>

          <br />
          <br />
          <ul>
            <li class="m-b-8">
              <b-link class="txt" @click="onClickForgot">
                Forgot password?
              </b-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { login } from '@/api/login'

export default {
  data() {
    return {
      mainProps: { width: 200, height: 200, class: "m1" },
      data: {
        email: "",
        password: ""
      },

      error: {
        submit: ""
      },
      loading: false
    };
  },

  methods: {
    onClickForgot() {
      this.$router.push({ path: `email` });
    },
    onClickLogin() {
      this.loading = true;
      this.error.submit = "";
      this.$store
        .dispatch("retrieveToken", {
          username: this.data.email,
          password: this.data.password,
          login_status: "1"
        })
        .then(res => {
          this.loading = false;
          if (res.data.response && res.data.response.code === 1) {
            this.$router.push({ name: "dashboard" });
          }
        })
        .catch(error => {
          this.loading = false;
          this.serverError = error.response.data;
          this.error.submit = "Email/password is invalid";
          this.email = "";
          this.password = "";
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.css";
@import "../../assets/css/util.css";
</style>
